import baseEn from '@gasbi/localizations/en.json';
import baseUa from '@gasbi/localizations/ua.json';
import { extendLocale } from '@gasbi/shared/common/utils';

import en from './en.json';
import ua from './ua.json';

export const LOCALE_NS = 'supplyBusinessAccount';

export const locales = {
  ua: { [LOCALE_NS]: extendLocale(baseUa, ua) },
  en: { [LOCALE_NS]: extendLocale(baseEn, en) },
};

const lng = 'ua';
const supportedLangs = ['ua', 'en'];
const fallbackLng = 'ua';
const defaultNS = LOCALE_NS;

export const i18nInstanceOptions = {
  locales,
  lng,
  supportedLangs,
  fallbackLng,
  defaultNS,
};
